import { collectValuesFromContainer } from "../../lib/snapshotValues";
import type { KeyValuePair as SharedKeyValuePair } from "../../lib/normalizeSectionInputs";
import { convertPairsToObject } from "./convertPairsToObject";

export type KeyValuePair = SharedKeyValuePair;
export type AcroFormValues = { [name: string]: string };

export function handleSubmitForm(params: {
  containerSelector: string;
  collectCurrentKeyValuePairs: () => KeyValuePair[];
  sectionInputs: { [sectionKey: string]: AcroFormValues };
  sectionPairs: { [sectionKey: string]: KeyValuePair[] };
  currentSectionIndex: number;
  submit: (args: { payload: unknown; saveData: KeyValuePair[] }) => void;
}) {
  const {
    containerSelector,
    collectCurrentKeyValuePairs,
    sectionInputs,
    sectionPairs,
    currentSectionIndex,
    submit,
  } = params;

  const container = document.querySelector(containerSelector);
  const currentValues = collectValuesFromContainer(container as Element | null, true) as AcroFormValues;
  const currentPairs = collectCurrentKeyValuePairs();
  const sectionKey = String(currentSectionIndex);

  const updatedSectionInputs = { ...sectionInputs, [sectionKey]: currentValues };
  const updatedSectionPairs = { ...sectionPairs, [sectionKey]: currentPairs };

  const fromSectionPairs: KeyValuePair[] = [];
  Object.values(updatedSectionPairs).forEach((sectionData) => {
    if (Array.isArray(sectionData)) {
      fromSectionPairs.push(...sectionData);
    }
  });

  const latestByKey = new Map<string, string | number | boolean>();
  fromSectionPairs.forEach((p) => latestByKey.set(p.key, p.value));
  currentPairs.forEach((p) => latestByKey.set(p.key, p.value));

  const finalPairs: KeyValuePair[] = Array.from(latestByKey.entries()).map(([key, value]) => ({ key, value }));
  const payloadObject = convertPairsToObject(finalPairs);
  submit({ payload: payloadObject, saveData: finalPairs });
}
